import { Stack } from 'ui';

import { formatSampleValue } from '../../utils/formatSampleValue/formatSampleValue';
import { MaterialBreakdownItem } from '../MaterialBreakdownItem/MaterialBreakdownItem';
import type { Item } from '../MaterialSampleBreakdown/MaterialSampleBreakdown';

export const GenericMaterialSampleBreakdown = ({ items, precision = 1 }: { items: Item[]; precision?: number }) => {
  return (
    <Stack
      sx={{
        gap: 2,
      }}
    >
      {items.map((item) => (
        <MaterialBreakdownItem key={item.label} label={item.label} value={formatSampleValue(item, precision)} />
      ))}
    </Stack>
  );
};
